import { unByKey } from "ol/Observable";
import { getRenderPixel } from "ol/render";

export const spyMap = ({ map, layers, borderLayer, sidoBorderLayer }) => {
    let radius = 75;
    let mousePosition = null;
    const container = document.getElementById("map_area");

    const keydownEvent = (event) => {
        if (event.key === 'ArrowUp') {
            radius = Math.min(radius + 5, 150);
            map.render();
            event.preventDefault();
          } else if (event.key === 'ArrowDown') {
            radius = Math.max(radius - 5, 25);
            map.render();
            event.preventDefault();
          }
    }

    const mouseMoveEvent = (event) => {
        mousePosition = map.getEventPixel(event);
        map.render();
    }

    const mouseOutEvent = () => {
        mousePosition = null;
        map.render();
    }

    const mountEvent = () => {
        layers[0].setVisible(true);
        layers[1].setVisible(true);
        borderLayer.setVisible(true);
        sidoBorderLayer.setVisible(true);
          
        document.addEventListener("keydown", keydownEvent);
        container.addEventListener("mousemove", mouseMoveEvent);
        container.addEventListener("mouseout", mouseOutEvent);

        const preRenderHandle = (event) => {
            const ctx = event.context;
            ctx.save();
            ctx.beginPath();
            if (mousePosition) {
              const pixel = getRenderPixel(event, mousePosition);
              const offset = getRenderPixel(event, [
                mousePosition[0] + radius,
                mousePosition[1],
              ]);
              const canvasRadius = Math.sqrt(
                Math.pow(offset[0] - pixel[0], 2) + Math.pow(offset[1] - pixel[1], 2)
              );
              ctx.arc(pixel[0], pixel[1], canvasRadius, 0, 2 * Math.PI);
              ctx.lineWidth = (5 * canvasRadius) / radius;
              ctx.strokeStyle = 'rgba(0,0,0,0.5)';
              ctx.stroke();
            }
            ctx.clip();
        }

        const postRenderHandle = (event) => {
            const ctx = event.context;
            ctx.restore();
        }

        const key0 = layers[1].on("prerender", preRenderHandle);
        const key1 = layers[1].on("postrender", postRenderHandle);

        return [key0, key1]
    }

    const dismountEvent = (spyEventKeyArray) => {
        spyEventKeyArray.forEach((key) => 
            unByKey(key)
        )

        document.removeEventListener("keydown", keydownEvent);

        if(container) {
          container.removeEventListener("mousemove", mouseMoveEvent);
          container.removeEventListener("mouseout", mouseOutEvent);
        }

        map.render();
    }

    return { mount: mountEvent, dismount: dismountEvent };
}